var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item"},[_c('div',{staticClass:"_fw-500 _fs-16 has-text-black"},[_vm._t("default")],2),_c('img',{attrs:{"src":require("@/assets/icon/chevron-right.svg"),"width":"24","height":"24"}})])}
var staticRenderFns = []

export { render, staticRenderFns }